import { useInfiniteQuery } from 'hooks/useInfiniteQuery'

import { fetchBookmarks } from 'utils/queries/bookmarks'

import { Bookmark } from 'types/bookmark'

export const useInfiniteBookmarks = ({
  userId,
  order = 'created',
  limit = 10,
}: {
  userId?: string
  order?: keyof Bookmark
  limit?: number
}) => {
  return useInfiniteQuery<Bookmark[]>(
    ['bookmarks', userId, order, limit],
    ({ pageParam }) =>
      fetchBookmarks({ userId }, { order, orderDirection: 'desc', lastVisible: pageParam, limit }),
    {
      getNextPageParam: (lastPage) => {
        // Very important, as the last page might not have any results
        if (!lastPage || !lastPage.length || lastPage.length < limit) return undefined

        return lastPage[lastPage.length - 1][order]
      },
    },
  )
}
